import { useState } from "react";
import { useHistory } from "react-router-dom";
import general from "../../general";
import { CloseCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { url } from "../../config";
import { useLocalStorageState, useToggle } from "ahooks";
import useActiveState from "../../lib/useActiveState";
import Dialog from "../../lib/Dialog";
import { behaviorTrigger } from "../../utils/trigger";
import { useLogin } from "../../lib/LoginContext";
import { storageLocal, sessionLocal } from "../../view/util/storage";
import CryptoJS from "crypto-js";

// 快速注册
export default () => {
  const history = useHistory();
  const { aplus_queue } = window;
  const [app] = useActiveState("app");

  const { setShowLogin, setIsFromLogin, setRegisterShow } = useLogin();

  const [isPlaintext, { toggle: toggleIsPlaintext }] = useToggle(false);
  const [isConfirmPlaintext, { toggle: toggleIsConfirmPlaintext }] =
    useToggle(false);

  const [data, setData] = useState({
    username: "",
    password: "",
    confirmPassword: "",
  });
  const [agreement, setAgreement] = useState(false);
  const [registering, setRegistering] = useState(false);
  const [datas, setDatas] = useLocalStorageState("users", { defaultValue: [] });

  let timer = null;
  const register = () => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      registerCode();
    }, 500);
  };

  const registerCode = () => {
    if (!data.username) {
      Dialog.error("请输入用户名");
      return;
    }

    if (!data.password) {
      Dialog.error("请输入密码");
      return;
    }

    if (!data.confirmPassword) {
      Dialog.error("请输入确认密码");
      return;
    }

    if (data.password != data.confirmPassword) {
      Dialog.error("两次输入的密码不一致");
      return;
    }

    if (!agreement) {
      Dialog.error(
        <div>
          注册前请阅读并同意
          <br />
          以下用户协议和隐私政策
        </div>,
      );
      return;
    }
    if (registering) {
      return;
    }
    setRegistering(true);
    Dialog.loading();

    general.axios
      .post("/v3/user/user/register_grpc", data)
      .finally(() => {
        setRegistering(false);
        Dialog.close();
      })
      .then(async (res) => {
        console.log("注册--------", res);
        let { status, data: result } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          localStorage.setItem("token", result.token);
          localStorage.setItem("user_id", result.user_id);
          localStorage.setItem("username", data.username);

          if (storageLocal.has("tgm_uuid")) {
            behaviorTrigger("register", {
              username: data.username,
              body: CryptoJS.enc.Base64.stringify(
                CryptoJS.enc.Utf8.parse(
                  JSON.stringify({
                    username: data.username,
                  }),
                ),
              ),
            });
          }

          setDatas([
            ...datas,
            { username: data.username, password: data.password },
          ]);
          aplus_queue.push({
            action: "aplus.record",
            arguments: [
              "register",
              "register",
              {
                agent: localStorage.getItem("agent"),
                username: data.username,
              },
            ],
          });

          setRegisterShow(false);
          setShowLogin(false);
          document.body.style.overflow = "";

          await getPopup();
          if (!storageLocal.has("jjAgentShow")) {
            Dialog.success("注册成功", () => history.push("/phone"));
          }
        }
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  };

  const getPopup = async () => {
    await general.axios
      .post("/v3/movable/popup/popup")
      .then(({ data: resData }) => {
        console.log("新人福利弹窗--------", resData);
        let { status, data } = resData;

        if (status.succeed) {
          if (storageLocal.has("jjAgentShow") && data.title == "新人见面礼") {
            let url = `${data?.jump_value}?origin=react&agent=${
              app.agent
            }&brand=${app.brand}&username=${localStorage.getItem(
              "username",
            )}&token=${localStorage.getItem("token")}`;

            Dialog.success("注册成功", () =>
              history.replace(
                `/iframe?url=${encodeURIComponent(
                  url,
                )}&title=新人见面礼&gohome=1`,
              ),
            );

            return;
          }

          sessionLocal.set("popupData", {
            ...data,
            route: data?.jump_value,
          });

          if (storageLocal.has("jjAgentShow")) {
            window.location.reload();
          }
        }
      });
  };

  let clickCount = 0;

  return (
    <div className="account-phonelogin account-login">
      <div className="phonelogin-body body">
        <div className="input">
          <div className="input-content">
            <input
              name="username"
              type="text"
              value={data.username}
              placeholder="请输入手机号或者用户名"
              autoComplete="off"
              onChange={(e) => setData({ ...data, username: e.target.value })}
              onMouseDown={() => {
                clickCount++;
                if (clickCount > 2) {
                  Dialog.info(
                    <div>
                      若遇到iOS系统键盘问题，请
                      <br />
                      重启手机或我的-&gt;联系客服
                    </div>,
                  );
                  clickCount = 0;
                }
              }}
            />
            {data.username ? (
              <CloseCircleOutlined
                className="clear"
                style={{ marginRight: 0 }}
                onClick={() => setData({ ...data, username: "" })}
              />
            ) : null}
          </div>
        </div>

        <div className="input code">
          <div className="input-content">
            <input
              name="password"
              type={isPlaintext ? "text" : "password"}
              value={data.password}
              placeholder="请输入密码"
              onChange={(e) => setData({ ...data, password: e.target.value })}
              onMouseDown={() => {
                clickCount++;
                if (clickCount > 2) {
                  Dialog.info(
                    <div>
                      若遇到iOS系统键盘问题，请
                      <br />
                      重启手机或我的-&gt;联系客服
                    </div>,
                  );
                  clickCount = 0;
                }
              }}
            />

            {data.password ? (
              <>
                <CloseCircleOutlined
                  className="clear"
                  onClick={() => setData((data) => ({ ...data, password: "" }))}
                />
              </>
            ) : null}

            <div className="psw-eye" onClick={() => toggleIsPlaintext()}>
              {isPlaintext ? (
                <img src="/resources/account/hidden.png" />
              ) : (
                <img src="/resources/account/show.png" />
              )}
            </div>
          </div>
        </div>

        <div className="input code">
          <div className="input-content">
            <input
              name="confirmPassword"
              type={isConfirmPlaintext ? "text" : "password"}
              value={data.confirmPassword}
              placeholder="请再次输入密码"
              onChange={(e) =>
                setData({ ...data, confirmPassword: e.target.value })
              }
              onMouseDown={() => {
                clickCount++;
                if (clickCount > 2) {
                  Dialog.info(
                    <div>
                      若遇到iOS系统键盘问题，请
                      <br />
                      重启手机或我的-&gt;联系客服
                    </div>,
                  );
                  clickCount = 0;
                }
              }}
            />

            {data.confirmPassword ? (
              <>
                <CloseCircleOutlined
                  className="clear"
                  onClick={() =>
                    setData((data) => ({ ...data, confirmPassword: "" }))
                  }
                />
              </>
            ) : null}

            <div className="psw-eye" onClick={() => toggleIsConfirmPlaintext()}>
              {isConfirmPlaintext ? (
                <img src="/resources/account/hidden.png" />
              ) : (
                <img src="/resources/account/show.png" />
              )}
            </div>
          </div>
        </div>

        <div
          className={"btn " + (registering ? "disable" : "")}
          style={{ marginTop: "28px" }}
          onClick={register}
        >
          确认注册
        </div>
      </div>

      <div className="account-agreement" style={{ marginTop: "37px" }}>
        {agreement ? (
          <>
            <CheckCircleOutlined className="checked" />
            我已阅读并同意
          </>
        ) : (
          <div
            style={{ display: "flex", alignItems: "center" }}
            onClick={() => setAgreement(true)}
          >
            <div className="unchecked"></div>
            我已阅读并同意
          </div>
        )}
        <div
          className="agreement-link"
          onClick={() => {
            setIsFromLogin(true);

            setTimeout(() => {
              history.push(
                "/iframe?url=" + url + "/userAgreement&title=用户协议",
              );
            }, 100);
          }}
        >
          《用户协议》
        </div>
        、
        <div
          className="agreement-link"
          onClick={() => {
            setIsFromLogin(true);

            setTimeout(() => {
              history.push(
                "/iframe?url=" + url + "/privacyPolicy&title=隐私政策",
              );
            }, 100);
          }}
        >
          《隐私政策》
        </div>
      </div>
    </div>
  );
};
